import { ca } from '@cian/analytics';

type TEventAction = 'show' | 'click';

export interface IUserTrackingData {
  abGroup: number;
  userId?: number;
  cianUserId?: number;
  email?: string;
  type?: string;
}

export function trackMortgageBanner(action: TEventAction, user: IUserTrackingData, bannerId: string) {
  ca('eventSite', {
    name: 'ipotekaevent',
    action,
    category: 'BannerIpoteka',
    label: bannerId,
    user,
    page: {
      pageType: 'Home',
      siteType: 'desktop',
    },
  });
}
